import { DealVersion } from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

export type DealActiveVersion = Pick<
  DealVersion,
  'id' | 'status' | 'isValidatedByBrand' | 'isValidatedByChoose'
>;

export const dealActiveVersionState = atom<DealActiveVersion | null>(null);
